import { motion } from "framer-motion";
import styled, { css, CSSProperties } from "styled-components";
import { Flex } from "../Flex/Flex.js";
import { rem } from "../Theme/Theme.constants.js";

export const LoaderWrapper = styled(Flex)`
    padding: ${(props) => `${props.theme.spacing[8]} ${props.theme.spacing[16]}`};
`;

export const PopoverContainer = styled.div<{ maxMenuHeight?: string }>`
    height: 100%;
    z-index: ${({ theme }) => theme.elevationLevels.max};
    color: ${({ theme }) => theme.grayscale[100]};

    & .infinite-scroll-component {
        max-height: ${({ maxMenuHeight }) => maxMenuHeight || rem(20)};
        overflow-y: auto;
        z-index: ${({ theme }) => theme.elevationLevels.max};
    }
`;

export const ArrowWrapper = styled(motion.div)`
    display: flex;
    align-items: center;
`;

export const InputWrapper = styled.div<{
    width?: CSSProperties["width"];
    minWidth?: CSSProperties["minWidth"];
    showArrowOnHover?: boolean;
    isMenuOpen?: boolean;
}>`
    width: ${({ width }) => width};
    min-width: ${({ minWidth }) => minWidth};

    ${({ showArrowOnHover, isMenuOpen }) =>
        showArrowOnHover &&
        css`
            .arrow-wrapper:first-child {
                display: ${isMenuOpen ? "flex" : "none"};
            }
            &:hover {
                .arrow-wrapper:first-child {
                    display: flex;
                }
            }
        `}
`;
